<template>
  <div class="mySubDepartment">
    <toptitle :title1="titlework" />

    <form action="/">
      <van-search v-model="value"
                  placeholder="请搜索用户"
                  @search="onSearch"
                  @input="inputSearch">
        <template #action>
          <div @click="onCancel">取消</div>
        </template>
      </van-search>
    </form>
    <van-list v-if="value.length > 0"
              :finished="loadFinished"
              v-model="loading"
              @load="loadMore"
              finished-text="没有更多了">

      <van-cell v-for="(item, index) in teamEmployeeList"
                :key="index"
                @click="chooseItem(item)">
        <template #title>
          <span class="custom-title">{{ item.NAME }}</span>
          {{ item.DEPT_DESCR }}
        </template>
      </van-cell>

    </van-list>

    <div class="department"
         v-else>
      <div class="top-nav">
        <van-swipe-cell>
          <ul class="breakcrumb">
            <li>
              <router-link to="/"
                           class="link-a">首页</router-link>
            </li>
            <li>
              <router-link to="/myteam"
                           class="link-a">组织架构</router-link>
            </li>
            <li>
              {{companyTitle}}
            </li>
          </ul>
        </van-swipe-cell>
      </div>
      <van-empty class="empty-section"
                 v-show="emptyShow"
                 description="暂无部门数据" />

      <section>
        <div class="dept-id"
             v-for="(item,index) in subdepartmentData"
             :key="index"
             @click="gotoEmployeesList(item)">
          <div class="divimg">
            <van-icon name="cluster-o"
                      size="20px" />
          </div>
          <div class="divwork">
            <p>{{item.DEPT_DESCR}}({{item.TOTAL}})</p>
          </div>
        </div>
      </section>
      <loading-show :isLoadindShow="loading"></loading-show>
    </div>

  </div>
</template>

<script>
import { subDepartmentDataApi, GetMyTeamDataApi } from '../../request/api'
import toptitle from '../../components/toptitle'
import LoadingShow from '../../components/loading'
import List from '../../components/myteam/List'

export default {
  components: { toptitle, LoadingShow, List },
  data() {
    return {
      titlework: '我的团队',
      companyTitle: '',
      activeKey: 0,
      value: '',
      loading: false,
      loadFinished: false,
      emptyShow: false,
      currentPageNo: 1,
      maxPageNo: 0,
      teamEmployeeList: [],
      subdepartmentData: [],
      dataLength: '',
      // 搜索历史列表
      hislist: [],
      obj: {},
    }
  },
  created() {
    this.emplid = this.$route.query.EMPLID
    this.companyTitle = this.$route.query.companyTitle

    // 定义数组接收本地存储的历史记录
    let history = localStorage.hislist
    if (history) {
      // 将数组转字符串
      this.hislist = JSON.parse(history)
    }
  },
  mounted() {
    this.getSubDepartmentApi()
  },
  methods: {
    onSearch() {},
    /**
     * 搜索部门
     * **/
    inputSearch() {
      this.currentPageNo = 1
      if (this.value.length > 0) {
        this.getList(this.value, '15')
      } else {
        this.getList('', '15')
      }
    },
    onCancel() {
      this.value = ''
      this.getList('', '10000')
    },
    /**
     * 获取部门下人员数据
     * **/
    gotoEmployeesList(val) {
      this.$router.push({
        path: '/teamemployees',
        query: {
          levelDept: this.$route.query.DEPTID,
          DEPTID: val.DEPTID,
          EMPLID: this.emplid,
          companyTitle: this.$route.query.companyTitle,
          department: val.DEPT_DESCR,
          subStatus: this.$route.query.subStatus,
        },
      })
    },

    loadMore() {
      if (this.currentPageNo > this.maxPageNo) {
        //已经加载到了最后一页
        this.loadFinished = true
      } else {
        //加载下一页的数据
        this.currentPageNo++
        this.getList()
      }
    },
    /**
     * 获取数据列表
     * **/
    getList(value, num) {
      this.loading = true

      let params = {
        DEPTID: this.$route.query.DEPTID,
        PAGE: this.currentPageNo.toString(),
        RECORD: 10,
        POSITION_NBR: '',
        NAME: this.value,
      }
      GetMyTeamDataApi(params).then((res) => {
        if (res.CODE == 200) {
          let subBody = res.DATA.INFO

          //根据页面返回值决定是否要显示加载已完成的提示
          this.maxPageNo = parseInt(res.DATA.MAXPAGE)
          if (this.currentPageNo >= this.maxPageNo) {
            this.loadFinished = true
          } else {
            this.loadFinished = false
          }
          if (this.currentPageNo == 1) {
            //如果当前是第一页，清空相关数据
            this.teamEmployeeList = []
          }
          this.teamEmployeeList = this.teamEmployeeList.concat(subBody)
          this.loading = false
        }
      })
    },
    /**
     * 获取查看团队成员信息
     *  **/
    chooseItem(val) {
      this.obj = val

      // //如果有的话就删除重复
      this.hislist.forEach((item) => {
        if (item.EMPLID == this.obj.EMPLID) {
          this.hislist.splice(this.hislist.indexOf(item), 1) //this.hislist.indexOf(item) 可以找到它的下标
        }
      })
      //向数组第一位添加
      this.hislist.unshift(this.obj)

      //如果数组长度大于四，就删除最后一项
      if (this.hislist.length > 4) {
        this.hislist.splice(5, 1)
      }

      //本地存储历史记录数组
      localStorage.hislist = JSON.stringify(this.hislist)

      this.value = ''
      this.$store.commit('changeNum', this.obj.EMPLID)
      this.$router.push('/employees')
    },
    /**
     *获取相关部门数据
     * **/

    getSubDepartmentApi(val) {
      this.loading = true
      let params = {
        DEPTID: this.$route.query.DEPTID,
        EMPLID: this.$route.query.EMPLID,
      }
      subDepartmentDataApi(params).then((res) => {
        if (res.CODE === 200) {
          this.subdepartmentData = res.DATA
          this.dataLength = this.subdepartmentData.length
          if (this.dataLength == 0) {
            this.emptyShow = true
          } else {
            this.emptyShow = false
          }
          this.loading = false
        }
      })
    },
  },
}
</script>

<style  lang="less" scoped>
.top-nav {
  background: #fff;
}

section {
  background: #fff;
  padding: 5px 0px;
  // margin-bottom: 20px;
  .divname {
    color: black;
    font-size: 16px;
    font-weight: bold;
  }
  div {
    margin: 9px;
    p {
      color: black;
    }
  }

  .dept-id {
    font-size: 15px;
    border-top: 1px solid #e5e5e5;
    display: flex;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .divright {
    flex: 1;
    line-height: 55px;
    margin: 0 10px 0 0;
    color: #55a0f8;
    text-align: right;
  }
}
/deep/.van-search {
  background: none;
}
.empty-section {
  border-top: 1px solid #ccc;
}
.breakcrumb {
  display: flex;
  -webkit-box-flex: 1;
  overflow-x: scroll;
  white-space: nowrap;
  vertical-align: middle;
  height: 45px;
  margin: 0 0 0 5%;
  padding: 0;
  line-height: 45px;

  &::-webkit-scrollbar {
    height: 0;
    width: 0;
  }

  li {
    padding-right: 18px;
    font-size: 14px;
    .link-a {
      background: none;
    }
  }
  li:not(:last-child) {
    a {
      color: #5076b7;
    }
  }
  li:not(:last-child):after {
    display: inline-block;
    content: ' ';
    width: 5px;
    height: 5px;
    border-top: 1px solid #656565;
    border-right: 1px solid #656565;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    position: relative;
    left: 10px;
    top: -2px;
    color: #5076b7;
  }
}
.breakcrumb::-webkit-scrollbar {
  display: none;
}
.empty-section {
  background: #fff;
}
</style>

